import * as React from 'react';
import { FilePreviewsItem } from '../FilePreviewsItem';
import * as styles from './FilePreviews.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FilePreviews = function FilePreviews(_ref) {
  var files = _ref.files,
    status = _ref.status,
    onRemove = _ref.onRemove,
    onRetry = _ref.onRetry;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: files.map(function (file, index) {
      var currentStatus = status[index];
      var isLoading = Array.of('initial', 'loading').includes(currentStatus);
      var isError = currentStatus === 'failed';
      return /*#__PURE__*/_jsx(FilePreviewsItem, {
        file: file,
        loading: isLoading,
        error: isError,
        onRemove: function (_onRemove) {
          function onRemove() {
            return _onRemove.apply(this, arguments);
          }
          onRemove.toString = function () {
            return _onRemove.toString();
          };
          return onRemove;
        }(function () {
          return onRemove(file);
        }),
        onRetry: function (_onRetry) {
          function onRetry() {
            return _onRetry.apply(this, arguments);
          }
          onRetry.toString = function () {
            return _onRetry.toString();
          };
          return onRetry;
        }(function () {
          return onRetry(file);
        })
      }, "file_".concat(index));
    })
  });
};